import { call, put, takeEvery } from "redux-saga/effects";
import { IServiceResult } from "../../../Models/IServiceResult";
import {
    getUSAWKTFailure,
    setUSAWKT,
    getRedirectLinkFailure,
} from "../Actions/CommonActions";
import * as api from "../API/CommonApi";
import {
    GET_USA_WKT_INITIATE,
    GET_REDIRECT_LINK_INITIATE,
    GetRedirectLinkInitiateAction,
} from "../Types/CommonActionTypes";

export function* watchCommonSagas() {
    yield takeEvery(
        GET_USA_WKT_INITIATE,
        getUSAWKT,
    );
    yield takeEvery(
        GET_REDIRECT_LINK_INITIATE,
        getRedirectLinkSaga,
    );
}

export function* getUSAWKT() {
    try {
        const result: IServiceResult<string> = yield call(() =>
            api.getCountryWKT("USA")
        );
        yield put(setUSAWKT(result.data));
    } catch (e) {
        yield put(getUSAWKTFailure(e));
    }
}

export function* getRedirectLinkSaga(action: GetRedirectLinkInitiateAction) {
    try {
        const response = yield call(() => api.getRedirectLink(action.data));
        window.location.href = response.data;
    } catch (e) {
        yield put(getRedirectLinkFailure(e));
    }
}
